<template>
  <div class="main-page">
    <section class="page-section">
      <div class="container">
        <div class="grid">
          <div class="col-12 md:col-12 sm:col-12 comp-grid">
            <div>
              <form ref="observer" tag="form" @submit.prevent="startSaveRecord()" @reset="resetForm">
                <div>
                  <table class="p-datatable-table" style="width: 100%">
                    <tbody>
                      <tr v-for="(formData, row) in arrFormData" :key="row" class="input-row">
                        <div class="mx-2">
                          <div class="grid">
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Option Name *
                              </div>

                              <div class="">
                                <!-- <div class="field mb-0"> -->
                                <InputText ref="ctrloption_name" v-model.trim="formData.option_name" label="Option Name"
                                  type="text" placeholder="Option Name" pattern="^[A-Za-z- ]+$" class="w-full"
                                  :class="getErrorClass(row, 'option_name')">
                                </InputText>
                                <!-- </div> -->
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Required SHS Courses <i>(optional)</i>
                              </div>

                              <div class="">
                                <!-- <div class="field mb-0"> -->
                                <api-data-source @loaded="(response) =>
                                    mapOptionField(response, 'option_required_electives')
                                  " :api-path="`components_data/caps_shs_courses_option_list`">
                                  <template v-slot="req">
                                    <MultiSelect class="w-full"
                                      optionLabel="label" optionValue="value" ref="ctrloption_required_electives"
                                      v-model="formData.option_required_electives" :options="req.response"
                                      label="Option Required Electives">
                                    </MultiSelect>
                                  </template>
                                </api-data-source>

                                <!-- </div> -->
                              </div>
                            </div>
                          </div>
                        </div>
                        <th>
                          <Button class="p-button-text p-button-danger p-button-rounded p-button-sm"
                            v-if="arrFormData.length >= minRowCount" @click="removeFormRow(row)" icon="pi pi-times" />
                        </th>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="100" class="text-left">
                          <Button v-if="arrFormData.length < maxRowCount" @click="addFormRow()" icon="pi pi-plus"
                            label="Add New" class="p-button-text p-button-success p-button-rounded p-button-sm" />
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </form>
              <slot :submit="submit" :saving="saving"></slot>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { mapActions, mapGetters, mapState } from "vuex";
import { AddPageMixin } from "../../mixins/addpage.js";
import { PageMixin } from "../../mixins/page.js";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "addprogrammeoptionsPage",
  components: {},
  mixins: [PageMixin, AddPageMixin],
  props: {
    pageName: {
      type: String,
      default: "add_programme_options",
    },
    maxRowCount: {
      type: Number,
      default: 10,
    },
    minRowCount: {
      type: Number,
      default: 1,
    },
    programmeoptions: { type: String, default: "[]" },
  },
  data() {
    return {
      arrFormData: [
        // {
        //   option_name: "",
        //   option_required_electives: "",
        // },
      ],
    };
  },
  validations() {
    let arrFormData = {
      $each: helpers.forEach({
        option_name: { required },
        option_required_electives: {},
      }),
    };
    return { arrFormData };
  },
  computed: {
    pageTitle: {
      get: function () {
        return "Add Programme Options";
      },
    },
  },
  methods: {
    ...mapActions("exam_sittings", ["saveRecord"]),
    async startSaveRecord() {
      this.submitted = true;
      const isFormValid = await this.v$.$validate();
      if (!isFormValid) {
        let errors = this.v$.arrFormData.$each.$response.$errors;
        this.flashMsg("Form is invalid", "", "error");
        return;
      }
      this.saving = true;
      let payload = this.normalizedFormData();
      let url = this.apiUrl;
      let data = { url, payload };
      this.saveRecord(data).then(
        (response) => {
          this.saving = false;
          this.resetForm();
          this.closeDialogs(); // close page dialog that if opened
          this.flashMsg(this.msgAfterSave);
          this.$emit("submitted", this.record);
        },
        (response) => {
          this.saving = false;
          this.showPageRequestError(response);
        }
      );
    },
    getProgrammeOptions() {
      if (this.programmeoptions) {
        this.arrFormData = JSON.parse(this.programmeoptions);
        // this.arrFormData.forEach(function (item, index) {
        //   item.option_required_electives = this.$utils.toArray(
        //     item.option_required_elective
        //   );
        // });
      }
    },
    addFormRow() {
      let newFormData = {
        option_name: "",
        option_required_electives: "",
      };
      this.arrFormData.push(newFormData);
    },
    removeFormRow(index) {
      this.arrFormData.splice(index, 1);
    },
    resetForm() {
      this.arrFormData = [
        {
          option_name: "",
          option_required_electives: "",
        },
      ];
      this.updateFormData();
    },
    getErrorClass(row, field) {
      let errors = this.v$.arrFormData.$each.$response.$errors[row][field];
      return { "p-invalid": errors.length && this.submitted };
    },
  },
  watch: {},
  async mounted() {
    this.getProgrammeOptions();
  },
  async created() { },
};
</script>
<style scoped></style>
